<template>
    <Carousel :autoplay="6000" :wrap-around="true">
        <Slide v-for="(image, index) of images" :key="image">
            <button @click="show(index)" class="carousel__item">
                <img :src="image" alt="" />
            </button>
        </Slide>

        <template #addons>
            <Navigation />
            <Pagination />
        </template>
    </Carousel>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";

export default defineComponent({
    name: "Basic",
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    data() {
        return {
            images: [
                "./images/slider/corporativo.png",
                "./images/slider/1_suzuki.png",
                "./images/slider/2_jac.png",
                "./images/slider/3_isu.png",
                "./images/slider/4_hyu.png",
                "./images/slider/5_vw.png",
                "./images/slider/6_kia.jpg",
                "./images/slider/7_toyota.jpg",
                "./images/slider/promocion1.png",
                "./images/slider/promocion2.png",
                "./images/slider/promocion3.jpg",
            ],
        };
    },
    methods: {
        show(index) {
            this.$attrs.onShowmodal(index)
        },
    },
});
</script>

<style>
.carousel__item {
    width: 100%;
    font-size: 20px;
    border-radius: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.carousel__slide {
    padding: 0px;
}

.carousel__pagination {
    margin: -40px 0 0;
    z-index: 10;
    position: absolute;
    width: 100%;
}

.carousel__pagination-button::after {
    width: 30px;
}
</style>